export default __webpack_public_path__ + "static/media/plus.f8cd1fc0.svg";